export { default } from './Clock';
